import { SubcategorySectionHeader } from './SubcategorySectionHeader';

export default SubcategorySectionHeader;
